import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-digital-technology',
  imports: [PillarPagesTemp],
  templateUrl: './digital-technology.html',
  styleUrl: './digital-technology.scss',
})
export class DigitalTechnology {

}
